import { ButtonContainer, Form } from './SelectPage.styled';
import Wrapper from '../Wrapper/Wrapper';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';
import { usePageTitle } from 'utils/hooks/usePageTitle';
import Button from 'components/Button/Button';
import ScrollableList from 'components/ScrollableList/ScrollableList';
import { ICompany } from 'types/Company.types';
import { useDebounce } from 'utils/hooks/useDebounce';
import { useNavigate } from 'react-router-dom';
import { RoutesConfig } from 'navigation/routes';
import { useGetCompaniesEligible, useSelectCompanyLogin } from './hooks';
import { useHandleLoginSuccess } from 'utils/hooks/useHandleLoginSuccess';

const SelectPage = () => {
  const { t } = useTranslation();
  const { isPhone } = useBreakpointFlag();
  const [searchBy, setSearchBy] = useState<string>('');
  const navigate = useNavigate();
  const debouncedSearchBy = useDebounce(searchBy);

  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get('token');
  const lang = searchParams.get('lang');
  const companyName = searchParams.get('companyName');
  const userId = searchParams.get('userId');

  usePageTitle('Select company');

  const backToSignIn = () =>
    navigate(
      RoutesConfig.CompanyLogin.buildPath(
        token!,
        lang || 'en',
        companyName || ''
      )
    );

  const { data: companiesData, isLoading: isLoadingGetCompanies } =
    useGetCompaniesEligible(userId!, token!, debouncedSearchBy, backToSignIn);

  const {
    data: selectCompanyData,
    mutate: selectCompany,
    isLoading: isLoadingSelectCompany,
  } = useSelectCompanyLogin(token!, userId!, backToSignIn);

  useHandleLoginSuccess(selectCompanyData);

  const handleSelect = (company: { id: number; name: string }) => {
    selectCompany({ companyId: company.id });
  };

  return (
    <Wrapper title={t('Select company')}>
      <Form>
        <ScrollableList
          items={companiesData || []}
          isLoading={isLoadingSelectCompany}
          noContentLabel={t('No companies found')}
          onClick={(company: ICompany) => handleSelect(company)}
          onSearch={(str: string) => setSearchBy(str)}
          isOnPage={true}
          showModelId={false}
        />
        <ButtonContainer>
          <Button
            label={t('Create new company')}
            primary
            disabled={isLoadingGetCompanies}
            width={isPhone ? '100%' : '580rem'}
            height={'55rem'}
            onClick={() =>
              navigate(
                RoutesConfig.CompanyLoginDetails.buildPath(
                  token!,
                  lang || 'en',
                  companyName || '',
                  userId!
                )
              )
            }
          />
        </ButtonContainer>
      </Form>
    </Wrapper>
  );
};

export default SelectPage;
